import { useTranslation } from 'react-i18next';
import SVGIcon from '../../../components/atoms/icons';
import LanguageSelect from '../../../components/molecules/language-select';
import type { CabecalhoPainelProps } from '../types';

const CabecalhoPainel = ({
	sessaoFluxoUnico,
	aoSair,
}: CabecalhoPainelProps) => {
	const { t } = useTranslation();

	return (
	<header className="border-b border-[#d9e1ea] bg-white">
		<div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-4">
			<button
				className="flex items-center gap-2 font-mono text-sm font-bold text-[#03488e] transition-colors hover:text-[#2f70f0]"
				onClick={() => window.location.assign('/container-tracking?container=')}
				type="button"
			>
				<span className="size-3 rotate-45 rounded-sm bg-[#2f70f0]" />
				Container Tracking
			</button>
			<div className="flex items-center gap-3">
				<LanguageSelect className="w-36" />
				<button
					className="group flex items-center gap-2 rounded border border-[#d9e1ea] bg-white px-3 py-1.5 font-mono text-xs text-[#475569] transition-colors hover:border-[#2f70f0] hover:bg-[#f8fafc] hover:text-[#1f2937]"
					onClick={aoSair}
					title={t('login.sign_out')}
					type="button"
				>
					{sessaoFluxoUnico.nome} ({sessaoFluxoUnico.perfil})
					<span className="text-sm text-[#64748b] transition-colors group-hover:text-[#dc2626]">
						<SVGIcon
							className="size-3 [&_path]:fill-[#dc2626]"
							icon="SignOut"
						/>
					</span>
				</button>
			</div>
		</div>
	</header>
	);
};

export default CabecalhoPainel;
